import { NavigationError } from '@angular/router';

/**
 * Ошибка динамического импорта ленивого роута из-за устаревшего бандла: после
 * деплоя вкладка со старым `index.html` грузит `chunk-*.js` с прежним хешем,
 * новый билд его переименовал, сервер на 404 отдаёт `index.html` (`text/html`),
 * и `import()` падает.
 */
export function isStaleChunkError(error: unknown): boolean {
  const message = String((error as { message?: unknown } | null)?.message ?? error ?? '');

  return /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|module script.*mime type/i.test(message);
}

const RELOAD_MARK = 'stale-chunk-reload-at';

/**
 * Обработчик `withNavigationErrorHandler`: на устаревший chunk делает жёсткую
 * перезагрузку — свежий `index.html` подтянет актуальные хеши.
 *
 * ponytail: защита от цикла — метка в sessionStorage на 10 с. Если storage
 * недоступен и chunk битый по-настоящему, возможен редкий двойной reload;
 * тогда добавить in-memory флаг.
 */
export function reloadOnStaleChunk(error: Pick<NavigationError, 'error'>): void {
  if (!isStaleChunkError(error.error)) {
    return;
  }

  try {
    if (Date.now() - Number(sessionStorage.getItem(RELOAD_MARK) ?? 0) < 10_000) {
      return;
    }
    sessionStorage.setItem(RELOAD_MARK, String(Date.now()));
  } catch {
    /* sessionStorage недоступен — перезагружаемся без защиты от цикла */
  }

  location.reload();
}
